import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api, errMsg, fmtTime } from "@/lib/api";

export function AdminLeaderboard() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => Promise.all([api.get("/admin/leaderboard"), api.get("/admin/season")]).then(([lb, s]) => { setRows(lb.data); setStatus(s.data.status); }).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/season/reset-leaderboard", { confirm: "RESET" });
      toast.success(`Leaderboard reset — ${data.season_scores} scores, ${data.submissions} answers cleared`);
      setConfirm(""); load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4">
      <ul className="panel divide-y divide-slate-800" data-testid="admin-leaderboard-list">
        {rows.length === 0 && <li className="p-4 text-sm text-slate-500">No scores yet.</li>}
        {rows.map((r) => (
          <li key={r.user_id} className="flex items-center gap-3 px-4 py-3" data-testid={`admin-leaderboard-row-${r.rank}`}>
            <span className="w-8 font-mono text-sm font-bold text-slate-400">{r.rank}</span>
            <span className="flex-1 truncate text-sm font-medium">{r.display_name}</span>
            <span className="text-xs text-slate-500">{r.challenges_completed} done · {fmtTime(r.total_response_ms)}</span>
            <span className="font-mono text-sm font-semibold">{r.total_points}</span>
          </li>
        ))}
      </ul>
      <div className="panel border-rose-500/40 p-5" data-testid="admin-reset-panel">
        <p className="eyebrow text-rose-300">Danger zone · reset leaderboard</p>
        <p className="mt-2 text-sm text-slate-300">Clears every score, attempt and answer for the current season so a new season can start fresh. Accounts and questions are kept. {status === "ended" ? "The season has ended — safe to reset." : status === "live" ? "The season is still live: players will lose their progress." : ""}</p>
        <div className="mt-3 flex flex-col gap-2 sm:flex-row">
          <input className="field sm:max-w-xs" placeholder='Type RESET to confirm' value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="admin-reset-confirm-input" />
          <button onClick={reset} disabled={confirm !== "RESET" || busy} className="inline-flex items-center justify-center gap-2 rounded-xl bg-rose-500 px-5 py-3.5 font-semibold text-white transition-colors hover:bg-rose-400 disabled:opacity-40" data-testid="admin-reset-button"><RotateCcw size={16} /> {busy ? "Resetting…" : "Reset leaderboard"}</button>
        </div>
      </div>
    </div>
  );
}
